import { React, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { createHttpClient, handleRemoteError } from '../../utilities/httpclient';
import createUserSessionActivity from '../../utilities/usersessiontracking';
import { createDisplayAreaMessengerContext, DisplayAreaMessenger } from '../displayareamessenger/DisplayAreaMessenger';
import { APPLICATION_API_ENDPOINT } from '../../utilities/constants';

import '../../styles/main.css';
import '../../styles/searchquerycontainer.css';
import '../../styles/absgtable.css';
import '../../styles/x12.css';

export function X12FileContext (props)
{
    const navigate = useNavigate();
    const params = useParams();
    const [fileContext, setFileContext] = useState('...');
    const [fileName, setFileName] = useState('...');
    const [messageContext, setMessageContext] = useState(createDisplayAreaMessengerContext());

    const showErrorMessage = msg => {
        setMessageContext({});
        const newMessageContext = createDisplayAreaMessengerContext();
        newMessageContext.error.message = msg;
        setMessageContext(newMessageContext);
    };

    const fetchX12FileContext = async () => {
        setMessageContext({});
        const httpclient = createHttpClient();
        const data = {
            'X12CaseFileGuid': params.x12CaseFileGUID,
        };
        await httpclient.post(`${APPLICATION_API_ENDPOINT}/x12/fetchX12file`, data).then(response => {
            if (!response?.data?.context || !response?.data?.fileName)
                return;

            setFileContext(response.data.context);
            setFileName(response.data.fileName);
        }).catch(e => {
            (handleRemoteError(navigate, e) || showErrorMessage(e.response?.data || e.message));
        });
    };

    useEffect(() => {
        (async () => {
            createUserSessionActivity(window.location.pathname);
            await fetchX12FileContext();
        })();
    }, []);

    return (
        <div>
            <h3>X12 Validator: File Context</h3>
            <hr className="abcblue" />
            <DisplayAreaMessenger context={messageContext} />
            <h4>Case File Context for {fileName}</h4>
            <hr className="abcblue" />
            <pre className="filecontext">{fileContext}</pre>
        </div>
    );
}